import { cn } from '@/lib/utils'
import { PUBLIC_PAGE_GUTTER_CLASSES } from '@/components/layout/surface-page'

interface Props {
 className?: string
 children: React.ReactNode
}

export default function Container({ className, children }: Props) {
 return <div className={cn(PUBLIC_PAGE_GUTTER_CLASSES, className)}>{children}</div>
}
